const processRoute = {
	path: ':codeProject/billing',
	name: 'page-list-billing',
	meta: {
		title: 'Listado de Facturación',
	},
	props: true,
	component: () => import('@/pages/billing/page-list-billing'),
	children: [
		{
			path: ':id/detail',
			name: 'detail-billing',
			meta: {
				title: 'Resumen de Error',
			},
			props: true,
			component: () => import('@/components/billing/detail-billing'),
		},
		{
			path: ':id/detail-error',
			name: 'detail-error-billing',
			meta: {
				title: 'Detalle de Tipo de Documento',
			},
			props: true,
			component: () => import('@/components/billing/detail-error-billing'),
		},
	],
};

export default processRoute;



// WEBPACK FOOTER //
// ./src/router/billing.js